




















































































import { Component, Vue } from 'vue-property-decorator';

import { Device, Info } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient, CreateUserReq } from '@/services/CoreClient';

import GroupAccessEditSmall from '@/components/access/GroupAccessEditSmall.vue';
import GroupAccessEdit from '@/components/access/GroupAccessEdit.vue';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';

import moment from 'moment';

@Component({
  components: {
    Loading,
    VueError,
    SectionHeader,
    Success,
    GroupAccessEditSmall,
    GroupAccessEdit
  },
})
export default class CreateUser extends Vue {

  // our model
  info:Info = {} as Info;
  error:string = '';
  success:string = '';
  
  // our model
  dateTime = DateTime;
  dpValidFromTo:{start?:string, end?:string, shortcut?:string} = {};
  email:string = '';
  password:string = '';
  repeatPassword:string = '';
  level:string = 'admin';
  groupIdList:string[] = [];

  httpBusy:boolean = false;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  
  clearError() {

    // we clear all errors
    this.error = '';
    this.httpBusy = false;
  }

  async mounted() {

    const reply = await this.coreClient.getInfo();
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    this.info = reply.info as Info;
    
  }

  groupIdListUpdate(newGroupIdList:string[]) {
    this.groupIdList = newGroupIdList.concat();
  }

  get canCreateUser():boolean {
    return !this.httpBusy && this.groupIdList.length > 0;
  }

  async createUser() {

    this.httpBusy = true;

    this.error = '';
    
    const req:CreateUserReq = {
      email: this.email,
      password: this.password,
      level: this.level,
      groupIdList: this.groupIdList
    }

    if(this.dpValidFromTo && this.dpValidFromTo.start && this.dpValidFromTo.end) {
      req.validFrom = moment(this.dpValidFromTo.start, "YYYY-MM-DD hh:mm a").valueOf(),
      req.validTo = moment(this.dpValidFromTo.end, "YYYY-MM-DD hh:mm a").valueOf()
    }
  
    const reply = await this.coreClient.createUser(req);

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to create new user: ${reply.errorMsg}`;

    this.setSuccess(`User ${this.email} created successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }

  get dpMinDate():string {
    return moment().format();
  }

  get dpCustomShortcuts():object[] {
    return  [
      { key: 'next7Days', label: 'Next 7 days', value: () => ({start:moment(), end: moment().add(7, 'days')}) },
      { key: 'next30Days', label: 'Next 30 days', value: () => ({start:moment(), end: moment().add(30, 'days')}) },
      { key: 'next90Days', label: 'Next 3 months', value: () => ({start:moment(), end: moment().add(3, 'months')}) },
      { key: 'next180Days', label: 'Next 6 months', value: () => ({start:moment(), end: moment().add(6, 'months')}) }
    ];
  }


}
